exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n  margin-left: 10%;\n  height: 80%;\n  width: 70%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/yanir/Desktop/workspace/TheBooksLibrary/src/app/components/show-book/show-book.component.scss
// module id = ../../../../../src/app/components/show-book/show-book.component.scss
// module chunks = main